import { SchemaWidgetInstance } from '../SchemaWidgetClass'

export const reviewJson = (data: SchemaWidgetInstance, _page: unknown) => {
  return {
    '@context': 'https://schema.org',
    '@type': 'Review',
    name: data.get('name'),
    description: data.get('description'),
    reviewBody: data.get('reviewBody'),
    itemReviewed: {
      '@type': 'Product',
      name: data.get('itemName'),
      description: data.get('itemDescription'),
    },
    reviewRating: {
      '@type': 'Rating',
      ratingValue: data.get('ratingValue'),
    },
    author: {
      '@type': 'Person',
      name: data.get('authorName'),
    },
  }
}
